export default __webpack_public_path__ + "_/images/hidden_temple_ru-aa8de224c981281951bc4f9cef365226a47923f60bf7df67a54461d7c7c301b7.jpg";